var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.9,1.6c1.9-1.1,4.1-1.4,6.2-.8,2.1,.5,3.9,1.8,5.1,3.6l-2.2-.3c-.2,0-.3,0-.3,.2,0,.2,0,.3,.2,.3l2.7,.4h0c.1,0,.3,0,.3-.2l.4-2.8c0-.1,0-.3-.2-.3-.1,0-.3,0-.3,.2l-.3,2c-1.2-1.7-2.9-3-4.9-3.6C9.6-.2,7.5-.1,5.6,.7,3.6,1.5,2.1,2.9,1.1,4.7,0,6.6-.2,8.7,.2,10.7c0,.1,.1,.2,.3,.2,0,0,0,0,0,0,0,0,.1,0,.2-.1,0,0,0-.1,0-.2-.3-1.7-.1-3.6,.6-5.2,.7-1.6,2-2.9,3.5-3.8h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.8,7.2c0-.2-.2-.2-.3-.2-.2,0-.2,.2-.2,.3,.4,1.9,0,3.9-.9,5.6-.9,1.7-2.4,3.1-4.2,3.8-1.8,.7-3.8,.8-5.7,.3-1.9-.6-3.5-1.8-4.6-3.4l2.2,.2c.2,0,.3,0,.3-.2,0-.2,0-.3-.2-.3l-2.8-.3h0c-.1,0-.3,.1-.3,.2l-.3,2.8c0,0,0,.1,0,.2,0,0,.1,0,.2,0h0c.1,0,.2-.1,.3-.3l.2-2c.8,1.2,1.9,2.2,3.2,2.9,1.3,.7,2.7,1,4.2,1,1.8,0,3.5-.5,5-1.5,1.5-1,2.6-2.4,3.3-4s.9-3.5,.5-5.2h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.4,14.1v-1.3c1.3-.2,2-1.1,2-2.1s-.6-1.8-1.9-2.3c-1.1-.5-1.5-.8-1.5-1.4s.4-1.1,1.3-1.1h0c.6,0,1.1,.1,1.6,.4l.3-.8c-.5-.3-1.1-.4-1.6-.4v-1.2h-.8v1.3c-1.1,.2-1.9,1-1.9,2s.8,1.7,2.1,2.2c.9,.4,1.4,.8,1.4,1.5s-.6,1.2-1.5,1.2h0c-.6,0-1.3-.2-1.8-.5l-.3,.8h0c.6,.4,1.2,.5,1.9,.5v1.3h.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/subscriptions.55ed219b175a8142703821c2863a74f7.svg";
export { ForwardRef as ReactComponent };